import { Toolbar } from 'components/Toolbar';
import { useAccess } from 'hooks/useAccess';
import { Button, cnMixSpace } from 'uikit';

import type { VariableIdType } from '../types';

type TCatalogPageToolbarProps = {
    handleOpenCreateOrEditDialog: (variableId: VariableIdType) => () => void;
    handleOpenVariableGroups: () => void;
    handleOpenTypeModal: () => void;
    handleOpenLimitModal?: () => void;
};

export const CatalogPageToolbar = ({
    handleOpenCreateOrEditDialog,
    handleOpenVariableGroups,
    handleOpenTypeModal,
    handleOpenLimitModal,
}: TCatalogPageToolbarProps) => {
    const { catalogs: catalogsRules } = useAccess();

    return (
        <Toolbar>
            <Button
                label="Создать переменную"
                onClick={handleOpenCreateOrEditDialog(null)}
                size="s"
                view="secondary"
                className={cnMixSpace({ mL: 'xl' })}
                disabled={!catalogsRules?.canEdit}
            />
            <Button
                label="Настроить группы переменных"
                onClick={handleOpenVariableGroups}
                size="s"
                view="secondary"
                className={cnMixSpace({ mL: 's' })}
                disabled={!catalogsRules?.canEdit}
            />
            <Button
                label="Настроить типы прочих"
                onClick={handleOpenTypeModal}
                size="s"
                view="secondary"
                className={cnMixSpace({ mL: 's' })}
                disabled={!catalogsRules?.canEdit}
            />
            {handleOpenLimitModal && (
                <Button
                    label="Настроить типы лимитированных"
                    onClick={handleOpenLimitModal}
                    size="s"
                    view="secondary"
                    className={cnMixSpace({ mL: 's' })}
                    disabled={!catalogsRules?.canEdit}
                />
            )}
        </Toolbar>
    );
};

CatalogPageToolbar.displayName = 'CatalogPageToolbar';
